import { useNavigate } from "react-router-dom";
import RegisterAvulsoView from "./view";
import usePersonalDataFormAvulso from "../hooks/usePersonalDataFormAvulso";

export default function RegisterAvulso() {
  const navigate = useNavigate();
  
  const goBack = () => {
    navigate("/");
  };
  
  const {
    isDisabled,
    register,
    handleSubmit,
    errors,
  } = usePersonalDataFormAvulso(navigate);

  return <RegisterAvulsoView
    goBack={goBack}
    isDisabled={isDisabled}
    register={register}
    errors={errors}
    handleSubmit={handleSubmit}
  />;
}

